import { Component, Input, forwardRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormControlSignature } from '../../controls';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { EntryPreviewComponent } from '../entry-preview/entry-preview.component';

@Component({
	selector: 'app-signature-button',
	templateUrl: './signature-button.component.html',
	styleUrls: ['./signature-button.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SignatureButtonComponent),
			multi: true
		}
	]
})
export class SignatureButtonComponent implements ControlValueAccessor {
	@Input() public dynamicFormControl: FormControlSignature;
	@Input() public form: UntypedFormGroup;

	public base64Signature: string;

	public constructor(private modalCtrl: ModalController) {}

	public writeValue(signatureValue: string): void {
		this.base64Signature = signatureValue;
	}

	public registerOnChange(fn: (_: any) => void): void {
		this.propagateChange = fn;
	}

	public registerOnTouched(): void {}
	public setDisabledState?(): void {}

	public async accessPreviewReport() {
		const modal = await this.modalCtrl.create({
			component: EntryPreviewComponent,
			cssClass: 'entry-preview-component',
			backdropDismiss: true,
			initialBreakpoint: 1,
			componentProps: {
				dynamicFormControl: this.dynamicFormControl
			},
			showBackdrop: true
		});

		await modal.present();
		const response = await modal.onDidDismiss<string>();

		this.form.get(this.dynamicFormControl.key).markAsDirty();
		this.propagateChange(response.data);
	}

	/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
	private propagateChange = (_: any) => {};
}
